import { Box, ButtonProps, styled } from '@material-ui/core';
import { CSSProperties } from 'react';
import { HeaderContainer } from './style';
import SButton from '../../../../sbutton';
import { SSearchInput } from '../../../ssearch';
import SText from '../../../../sui/stext';
import { TextColor } from '../../../../../enums';
import { distances } from '../../../../../styles';

export const FilterSearchInput = styled(SSearchInput)({
  width: '100%',
  borderRadius: 99,
  marginTop: distances.px.small,
  marginBottom: distances.px.small,
  background: '#F8F9FA',
  padding: `${distances.px.small} ${distances.px.base}`,
  '& fieldset': {
    borderColor: '#EEF0F2 !important'
  }
});

const ActionButton = ({ children, ...props }: ButtonProps) => (
  <SButton
    variant="text"
    size="small"
    style={{ fontSize: 12, minHeight: '0' }}
    {...props}>
    {children}
  </SButton>
);

export interface SelectMenuHeaderProps {
  title?: string;
  search?: boolean;
  clearButton?: boolean;
  placeholder?: string;
  defaultSearchValue?: string;
  searchValue?: string;
  closeButton?: boolean;
  onClose?: () => void;
  handleClear?: () => void;
  handleChange?: (value: string) => void;
  customSearch?: React.ReactNode;
  headerStyle?: CSSProperties;
}

const SelectMenuHeader = ({
  title,
  search = true,
  clearButton = false,
  closeButton = false,
  placeholder,
  defaultSearchValue,
  searchValue,
  onClose,
  handleClear,
  handleChange,
  customSearch,
  headerStyle = {}
}: SelectMenuHeaderProps) => (
  <Box width="100%">
    <HeaderContainer style={headerStyle}>
      {Boolean(title) && (
        <SText title={title} weight="bold" fontColor={TextColor.Grey} />
      )}
      {clearButton && handleClear && (
        <ActionButton onClick={handleClear}>Clear</ActionButton>
      )}
      {!clearButton && closeButton && onClose && (
        <ActionButton onClick={onClose}>Close</ActionButton>
      )}
    </HeaderContainer>
    {search && handleChange && (
      <FilterSearchInput
        width="100%"
        searchedValue={searchValue}
        defaultValue={defaultSearchValue}
        placeholder={placeholder}
        onChange={handleChange}
        style={{ width: '100%' }}
      />
    )}
    {customSearch}
  </Box>
);

export default SelectMenuHeader;
